import React, { useEffect, useState } from 'react'

import Icon from '../Icon2'
import { Truncate } from '../Truncate/Truncate'
import CollapsiblePillValue from './CollapsiblePillValue'

const dateType = ['updatedAt', 'createdAt', 'publishedAt'];

const CollapsiblePill = React.memo(({ id, isHide = false, groupHide = {}, setGroupHide, group, testId, testIdPrefix, leadingIcon, canTruncate, variant, onPillsCancelClick }: any) => {
	const hideState = typeof groupHide[id] !== "undefined" ? groupHide[id] : false
	const [hide, setHide] = useState(hideState);
	/*
	{
		"group_name": "Group Name",
		"values": [{}]
	}
	*/

	useEffect(() => {
		setHide(isHide)
	}, [isHide])

	const handleGroupHide = (e) => {
		e.preventDefault();
		setHide(!hide);
		setGroupHide((prvState) => {
			return {...prvState, [id]: !hide}
		});
	}

	return (
		<>
			<div className={`QueryPills__filter-pills-accordion`} data-test-id={testId}>
				<div className="Pill PillGroup" data-test-id={`${testIdPrefix}-accordion`}>
					<div className="PillItem flex-center PillItem__label PillItem__default" onClick={(handleGroupHide)}>
						<span className={"PillItem__text-content"}>
						{canTruncate ?
								<Truncate isResponsive truncateFrom='end' >{group.group_name}</Truncate>
								: group.group_name}
						</span>
						{hide && (<span className={"PillItem__text-sub-content"} data-test-id={`${testIdPrefix}-pill-count`} >{`(${group.values.length < 100 ? group.values.length : "99+"})`}</span>)}
						<div className={"PillIcon PillIcon__label--end flex-center"}>
						<Icon
								icon={!hide ? "MinusSign":  "Plus"}
								version="v2"
								size="extraSmall"
								
								testId={`${testId}-${!hide ?'hide': 'show'}`}
							/>
						</div>
					</div>
				</div>
			</div>
			{!hide && group.values.map((pill, index) => {
				const itemTestID = `${testId}-item-${index}`
				if (dateType.includes(pill.id)) {
					const dateRange = pill.value.split(' - ')
					return (
						<>
							<CollapsiblePillValue
								testId={`${itemTestID}-start`}
								leadingIcon={leadingIcon}
								canTruncate={canTruncate}
								variant={variant}
								handleClick={(e) => onPillsCancelClick(e, pill)}
								text={`> ${dateRange[0]}`}
								index={index}
								testIdPrefix={testIdPrefix}
							/>

							<CollapsiblePillValue
								testId={`${itemTestID}-end`}
								leadingIcon={leadingIcon}
								canTruncate={canTruncate}
								variant={variant}
								handleClick={(e) => onPillsCancelClick(e, pill)}
								text={`< ${dateRange[1]}`}
								index={index}
								testIdPrefix={testIdPrefix}
							/>
						</>
					)
				} else {
					return <CollapsiblePillValue
						testId={itemTestID}
						leadingIcon={leadingIcon}
						canTruncate={canTruncate}
						variant={variant}
						handleClick={(e) => onPillsCancelClick(e, pill)}
						text={pill.value}
						index={index}
						testIdPrefix={testIdPrefix}
					/>
				}
			}
			)}
		</>
	)
});

export default CollapsiblePill;